import React from "react";


function Administration() {
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/slider/slider-1.png)',backgroundSize:'cover',backgroundPosition:'center'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
        <h1 className="darsikal">മാർഗദർശികൾ</h1>
        <div className="row">
                      
        </div>

        <div className="row">
            <div className="col-md-12">
                <div className="row" style={{marginBottom:'50px'}}>
                    <div className="col-md-3 bottomrow" >
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/p-velu.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">പി.വേലു</p>
                            <p className="designation">കുടുംബ കാരണവർ (06.10.1984 ൽ ദിവംഗതനായി) </p>
                        </div>
                    </div>   
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/k-sreedharan.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">കെ. ശ്രീധരൻ</p>
                            <p className="designation">മാനേജിംഗ് ട്രസ്റ്റി (1991 - 2002)</p>
                        </div>
                    </div>  
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/v-gopalan.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">വി. ഗോപാലൻ</p>
                            <p className="designation">​വൈസ് പ്രസിഡന്റ് (1991 - 2000)</p>
                        </div>
                    </div>    
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/r-sivadasan.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">ആർ. ശിവദാസൻ</p>
                            <p className="designation">മാനേജിംഗ് ട്രസ്റ്റി (2001 - 2007)</p>
                        </div>
                    </div>     
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/k-sivadasan.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">കെ. ശിവദാസൻ</p>
                             <p className="designation">മാനേജിംഗ് ട്രസ്റ്റി (2007- 18) </p>
                        </div>
                    </div> 
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/s-prasobhan.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">എസ്. പ്രശോഭൻ (സെക്രട്ടറി) <br /> 1991-2007, 2010-16, 2019-22</p>
                            {/* <p className="designation">ഭരണസമിതി അംഗം </p> */}
                        </div>
                    </div> 
                   
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/sadanandan.jpeg)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">വി സദാനന്ദൻ <br /> (വൈസ് പ്രസിഡന്റ് - (2007-15)</p>
                            {/* <p className="designation">ഭരണസമിതി അംഗം </p> */}
                        </div>
                    </div> 
                                 
                </div>
           </div>            
        </div>

         {/* <div className="row" style={{borderTop:'5px solid orange',paddingTop:'50px',background:'orange',borderRadius:'15px'}}>
             <div className="col-md-12">
                <div className="row" style={{marginBottom:'50px'}}>
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/thanthri.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">തന്ത്രരത്നം പ്രശാന്ത് ജി നമ്പുതിരി  </p>
                            <p className="designation">ക്ഷേത്രതന്ത്രി</p>
                        </div>
                    </div>   
                    <div className="col-md-3">
                        <div>
                            <div className="member" style={{backgroundImage:'url(./images/melsanthi.png)', backgroundSize:'cover',backgroundPosition:'center'}}></div>
                            <p className="name">മാധവൻ നമ്പൂതിരി</p>
                            <p className="designation">മേൽശാന്തി</p>
                        </div>
                    </div>  
                     
                </div>

             </div>
         </div> */}

        <div className="row">
            <div className="col-md-12">
                <div className="row" style={{marginBottom:'50px'}}>
                                      
                </div>
           </div>            
        </div>
</div>
    </div>
  );
}

export default Administration;